// 会员资源配置页面
export const MEMBER_DEFAULT_RESOURCE_PAGE_UUID =
  '840d9686-4814-4025-81ab-1007df907ff8'

// 管理会员默认资源
export const MEMBER_DEFAULT_RESOURCE_ACTION_UUID =
  '9e976a41-45c2-416f-95d6-13272cc9af49'
